import { render, staticRenderFns } from "./AddProductDialog.vue?vue&type=template&id=6804a0a4"
import script from "./AddProductDialog.vue?vue&type=script&lang=js"
export * from "./AddProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports